import Image from '../../../components/Image/Image';
import Link from '../../../components/Link/Link';

function SubmitErrorPageBody(): JSX.Element {
  return (
    <div className='error-page__body'>
      <div className='error-page__heading'>
        <h1>Something's gone wrong.</h1>
        <Image
          classes='error-page__image'
          alt='page not found image'
          name='not-found.svg'
          width='76'
          height='100'
        />
      </div>

      <p>
        We can't seem to submit your form at the moment. Check to see if you
        have an email from us or{' '}
        <Link href='https://www.newcastlepermanent.com.au/contact-us'>
          get in touch
        </Link>{' '}
        for help.
      </p>

      <Link
        href='https://www.newcastlepermanent.com.au/'
        className='underline-reversed btn btn__primary'
      >
        Go to website
      </Link>
    </div>
  );
}

export default SubmitErrorPageBody;
